export class AlterarSenha{
    ID: string;
    Email: string;
    Senha: string;
    ConfirmaSenha: string;
}